import { Map, InfoWindow, Marker, GoogleApiWrapper } from 'google-maps-react';
import React, { Component } from 'react';
import './../../styles/global.scss';
export class SiteMapComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
    }
  }

  displayMarkers = () => {
    
      return <Marker key={this.props.site.id} id={this.props.site.id} position={{
                    lat: this.props.site.latitude,
                    lng: this.props.site.longitude
                  }}
                  >
                  <InfoWindow>
                    <p>Test</p>
                  </InfoWindow>
              </Marker>
     
  }

  render() {
    const mapStyles = {
      width: '100%',
      height: '100%',
    };
    return (
            <div className = "map">

              <Map
                google={this.props.google}
                zoom={6}
                style={mapStyles}
                initialCenter={{ lat: 54, lng: -4.2}}
              >
                {this.displayMarkers()}
              </Map>
        </div>

    );
  }
}

export default GoogleApiWrapper({
  apiKey: 'AIzaSyCZW5yOPF-dVT7GnT5OJfEYFsk4mqDgvTM'
})(SiteMapComponent);